module.exports = __webpack_public_path__ + "static/zendesk_logo-e57aaef18ccf089e279e0125b1607dfb.png";